var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInterpreter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_interpreter",
    d: "M18 8.80251C18 7.42989 17.2423 6.23155 16.1236 5.60181C15.4379 2.41303 12.3571 0 8.6706 0C4.77062 0 1.54831 2.70072 1.12294 6.16356C0.431383 6.83151 0 7.76731 0 8.80251C0 10.8266 1.64679 12.4734 3.67092 12.4734C3.81297 12.4734 3.92806 12.3583 3.92806 12.2163V5.38863C3.92806 5.24664 3.81297 5.13149 3.67092 5.13149C3.49807 5.13149 3.3282 5.14435 3.16157 5.16765C3.98031 3.1679 6.14073 1.73587 8.6706 1.73587C11.2044 1.73587 13.3675 3.17242 14.1833 5.17711C14.1161 5.2235 14.0719 5.3009 14.0719 5.38869V12.2163C14.0719 12.3583 14.187 12.4735 14.3291 12.4735C14.4141 12.4735 14.4982 12.4695 14.5819 12.4638C14.0125 14.2352 12.4713 15.6427 10.5096 16.1934C10.2748 15.8136 9.85464 15.5603 9.37527 15.5603H7.96593C7.22988 15.5603 6.63305 16.1571 6.63305 16.8932V17.1531C6.63305 17.8892 7.22988 18.486 7.96593 18.486H9.37527C10.0472 18.486 10.6029 17.9886 10.6946 17.3419C13.3334 16.648 15.3631 14.633 15.8598 12.1378C17.1216 11.5563 18 10.2804 18 8.80251Z",
    fill: "#B4C3D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInterpreter);
export default __webpack_public_path__ + "static/media/ic_interpreter.182e52185f291e9fa60a2161f3e9ae23.svg";
export { ForwardRef as ReactComponent };